(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;

    // ── Scroll reveal (soft fade-up) ───────────────────────────
    var io = hasIO
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pv-in'); io.unobserve(e.target); } });
        }, { threshold: 0.08 })
      : null;
    document.querySelectorAll('.pv-reveal').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('pv-in');
    });

    // ── Gold shine that sweeps across each title as it scrolls into view ──
    if (hasIO && !reduce) {
      var shineIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.classList.add('pv-shine-go');
          el.addEventListener('animationend', function () { el.classList.remove('pv-shine-go'); }, { once: true });
          shineIO.unobserve(el);
        });
      }, { threshold: 0.6 });
      document.querySelectorAll('.pv-section-h.pv-shine-on').forEach(function (h) { shineIO.observe(h); });
    }

    // ── Hero title: shine after the premium entrance settles, a touch slower ──
    if (!reduce) {
      var heroH1 = document.querySelector('.pv-about-hero .pv-about-h1');
      if (heroH1) {
        window.addEventListener('load', function () {
          setTimeout(function () {
            heroH1.classList.add('pv-shine-go', 'pv-shine-slow');
            heroH1.addEventListener('animationend', function () { heroH1.classList.remove('pv-shine-go'); heroH1.classList.remove('pv-shine-slow'); }, { once: true });
          }, 1200);
        });
      }
    }

    // ── Quote / display lines: words appear one by one as you scroll ──
    if (hasIO && !reduce) {
      var splitWords = function (el) {
        var text = el.textContent;
        if (!text || el.querySelector('.pv-word')) return;
        var parts = text.split(/(\s+)/);
        el.textContent = '';
        var i = 0;
        parts.forEach(function (p) {
          if (p === '') return;
          if (/^\s+$/.test(p)) { el.appendChild(document.createTextNode(p)); return; }
          var s = document.createElement('span');
          s.className = 'pv-word';
          s.textContent = p;
          s.style.transitionDelay = (i * 0.025) + 's';
          el.appendChild(s);
          i++;
        });
      };
      var wordIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pv-words-in'); wordIO.unobserve(e.target); } });
      }, { threshold: 0.25 });
      // Down-page quotes reveal their words on scroll.
      document.querySelectorAll('.pv-pullquote, .pv-closing-lead, .pv-closing-sign').forEach(function (el) {
        splitWords(el);
        wordIO.observe(el);
      });
      // The founder opening quote is part of the timed intro sequence below,
      // so split it now but DON'T scroll-trigger it (that fired it too early).
      var fq = document.querySelector('.pv-founder-quote');
      if (fq) splitWords(fq);
    }

    // ── Founder note: staged to flow on AFTER the hero entrance settles ──
    //   picture → quote mark → words one-by-one → signature
    if (!reduce) {
      var founder = document.querySelector('.pv-founder');
      if (founder) {
        setTimeout(function () { founder.classList.add('pv-go'); }, 700);
        setTimeout(function () {
          var fq2 = founder.querySelector('.pv-founder-quote');
          if (fq2) fq2.classList.add('pv-words-in');
        }, 1250);
      }
    }

    // ── Clone the trust-pill row into the footer slot ──────────
    (function () {
      var top = document.querySelector('nav.pv-trust-top');
      if (!top) return;
      var html = top.innerHTML;
      document.querySelectorAll('[data-pv-trust-clone]').forEach(function (c) { c.innerHTML = html; });
    })();

  });
})();
